const SearchMobileIcon = ({ ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      {...props}
    >
      <path
        d='M7.66668 14.5002C3.90001 14.5002 0.833344 11.4335 0.833344 7.66683C0.833344 3.90016 3.90001 0.833496 7.66668 0.833496C11.4333 0.833496 14.5 3.90016 14.5 7.66683C14.5 11.4335 11.4333 14.5002 7.66668 14.5002ZM7.66668 1.8335C4.44668 1.8335 1.83334 4.4535 1.83334 7.66683C1.83334 10.8802 4.44668 13.5002 7.66668 13.5002C10.8867 13.5002 13.5 10.8802 13.5 7.66683C13.5 4.4535 10.8867 1.8335 7.66668 1.8335Z'
        fill='#AAAAAA'
      />
      <path
        d='M14.6667 15.1666C14.54 15.1666 14.4133 15.12 14.3133 15.02L12.98 13.6866C12.7867 13.4933 12.7867 13.1733 12.98 12.98C13.1733 12.7866 13.4933 12.7866 13.6867 12.98L15.02 14.3133C15.2133 14.5066 15.2133 14.8266 15.02 15.02C14.92 15.12 14.7933 15.1666 14.6667 15.1666Z'
        fill='#AAAAAA'
      />
    </svg>
  );
};

export default SearchMobileIcon;
